// TODO: Remove after finish deprecating additional email
export const GET_ADDITIONAL_EMAIL_SUCCESS = "GET_ADDITIONAL_EMAIL_SUCCESS"

export const getAdditionalEmailSuccess = payload => ({
  type: GET_ADDITIONAL_EMAIL_SUCCESS,
  payload
})
